import { render, staticRenderFns } from "./FilterFacet.vue?vue&type=template&id=3f0db69a&scoped=true"
import script from "./FilterFacet.vue?vue&type=script&lang=js"
export * from "./FilterFacet.vue?vue&type=script&lang=js"
import style0 from "./FilterFacet.vue?vue&type=style&index=0&id=3f0db69a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f0db69a",
  null
  
)

export default component.exports